import { render, staticRenderFns } from "./RegenerativeWheel.vue?vue&type=template&id=5709c1a2&scoped=true&"
import script from "./RegenerativeWheel.vue?vue&type=script&lang=js&"
export * from "./RegenerativeWheel.vue?vue&type=script&lang=js&"
import style0 from "./RegenerativeWheel.vue?vue&type=style&index=0&id=5709c1a2&lang=scss&scoped=true&"
import style1 from "./RegenerativeWheel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5709c1a2",
  null
  
)

export default component.exports